import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { SUBMISSIONS } from '../constants'

const deleteSubmission = async ({
  campaignId,
  id,
}: {
  campaignId: number
  id: number
}) => {
  await fetchAPI({
    path: `/campaigns/${campaignId}/submissions/${id}`,
    method: 'delete',
  })
}

export const useDeleteSubmission = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deleteSubmission, {
    async onSuccess() {
      await queryClient.refetchQueries([SUBMISSIONS])

      toast({
        description: t('views.admin.campaigns.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
